export enum EnumMyCourseMenu {
  Teach = '1',
  Product = '2',
  Offline = '3'
}

export enum EnumMyStudyMenu {
  Homework = '1',
  Reward = '2',
  Daily = '3',
  Collect = '4'
}

export enum EnumMyAccountMenu {
  Order = '1',
  Bishan = '2',
  Coin = '3',
  Packs = '4',
  Exchange = '5'
}
